/*
  Life Inbox API client. Single responsibility: classify + capture + manage.
*/
import axios from "axios";
import { API, getClientId } from "./api";

const http = axios.create({ baseURL: `${API}/inbox` });
http.interceptors.request.use((cfg) => {
  cfg.headers["x-client-id"] = getClientId();
  return cfg;
});

export const inboxApi = {
  async classify(input) {
    const { data } = await http.post("/classify", { input });
    return data;
  },
  async capture(payload) {
    const { data } = await http.post("", payload);
    return data;
  },
  async list(params = {}) {
    const { data } = await http.get("", { params });
    return data;
  },
  async update(id, patch) {
    const { data } = await http.patch(`/${id}`, patch);
    return data;
  },
  async remove(id) {
    const { data } = await http.delete(`/${id}`);
    return data;
  },
};
